<template>
  <div class="page">
    <div v-if="loading" class="page__loader">
      <div class="loader">Loading...</div>
    </div>
    <h1>{{ $route.params.type }}</h1>
    <div class="page__info">
      <span>
        <a href="/" class="page__info-type">Domů</a> >
        <em>
          <span class="page__info-type">{{ $route.params.type }}</span>
        </em>
      </span>
    </div>
    <transition-group name="insert-portfolio" v-if="portfolioLinks" tag="div">
      <PortfolioLink v-for="(item, index) in portfolioLinks" :key="index" :item="item"></PortfolioLink>
    </transition-group>
  </div>
</template>

<script>
import axios from "axios";
import PortfolioLink from "@/components/PortfolioLink";

import moment from "moment";
moment.locale("cs");

export default {
  name: "page",
  components: {
    PortfolioLink,
  },
  data() {
    return {
      portfolioLinks: [],
      loading: true,
    };
  },
  created() {
    axios
      .get(`items/atelier_projekty?fields=type,date,heading,tags,slug,intro,intro_img.title,intro_img.id&filter[type]=${this.$route.params.type}`)
      .then((res) => {
        if (res.status == 200) {
          this.portfolioLinks = res.data.data;
          this.loading = false;
        } else {
          //some error handling
        }
      });
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM YYYY");
    },
  },
};
</script>
<style>
.page {
  padding: 0 48px;
}

.page > div {
  padding: 24px 0;
}

.page h1 {
  font-size: 4rem;
  text-align: center;
  letter-spacing: 0;
  margin: 64px 0 0 0;
  text-transform: capitalize;
}

.page__info {
  text-align: center;
}

.page__info > span {
  padding: 0 12px;
}

.page__info-type {
  text-transform: capitalize;
}

/* Loader */
.page__loader {
  display: flex;
  justify-page: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  margin: auto;
}

@media only screen and (min-width: 1200px) {
  .page {
    padding-left: 10vw;
    padding-right: 10vw;
  }
}

@media only screen and (max-width: 400px) {
  .page {
    padding: 0 24px;
  }
}
</style>
